import { useState, useEffect } from "react";

export function useTimeout(milliseconds: number) {
  const [elapsed, setElapsed] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => setElapsed(true), milliseconds);
    return () => clearTimeout(timeoutId);
  }, [milliseconds]);

  return elapsed;
}
